import { CasesNotification } from "@/types/notification"
import { AxiosInstance } from "axios"
import api from "./api"

class ApiNotification {
	private get axios (): AxiosInstance {
		return api.getAxios() as AxiosInstance
	}

	public async notificationList (): Promise<CasesNotification[]> {
		return (await this.axios.get("/notifications")).data
	}

	public async notificationDelete (casesNotification: CasesNotification): Promise<void> {
		await this.axios.delete(`/notifications/${casesNotification.id}`)
	}

	public async clearAllNotifications (): Promise<void> {
		await this.axios.delete("/notifications/deleteAll")
	}
}

const apiNotification = new ApiNotification()
export default apiNotification
